import { render, staticRenderFns } from "./AmendSelectedTrade.vue?vue&type=template&id=3fb18d08&scoped=true&"
import script from "./AmendSelectedTrade.vue?vue&type=script&lang=js&"
export * from "./AmendSelectedTrade.vue?vue&type=script&lang=js&"
import style0 from "./AmendSelectedTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AmendSelectedTrade.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./AmendSelectedTrade.vue?vue&type=style&index=2&id=3fb18d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb18d08",
  null
  
)

export default component.exports